// extracted by mini-css-extract-plugin
module.exports = {"uncategorized":"src-common-categories-main__uncategorized--3CK1A"};